/** Production developer documentation (Docusaurus on Vercel). */
export const PUBLIC_DOCS_SITE_URL = 'https://priorities-ai-docs.vercel.app';

export const publicDocsPath = (path: string) =>
  `${PUBLIC_DOCS_SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
